var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',[_c('p',[_vm._v(_vm._s(_vm.title)),_c('img',{attrs:{"src":require("../../../assets/shadow.png"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }